import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import generalStyles from './style/general.css';
import typeStyles from './style/type.css';
import typeSStyles from './style/typeS.css';
import typeMStyles from './style/typeM.css';
import typeLStyles from './style/typeL.css';

/**
 * Use the Align component to align text, `inline` and `inline-block` elements.
 */
export default function Align({ children, type, typeS, typeM, typeL }) {
  const isTable = type === 'top' || type === 'middle' || type === 'bottom';
  const isTableS = typeS === 'top' || typeS === 'middle' || typeS === 'bottom';
  const isTableM = typeM === 'top' || typeM === 'middle' || typeM === 'bottom';
  const isTableL = typeL === 'top' || typeL === 'middle' || typeL === 'bottom';

  const outerClasses = cx({
    [generalStyles.table]: isTable,
    [generalStyles.tableS]: isTableS,
    [generalStyles.tableM]: isTableM,
    [generalStyles.tableL]: isTableL,
  });

  const innerClasses = cx(typeStyles[type], {
    [typeSStyles[typeS]]: typeS,
    [typeMStyles[typeM]]: typeM,
    [typeLStyles[typeL]]: typeL,
  });

  return (
    <div className={outerClasses}>
      <div className={innerClasses}>{children}</div>
    </div>
  );
}

Align.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['left', 'center', 'right', 'top', 'middle', 'bottom']),
  typeS: PropTypes.oneOf([
    'left',
    'center',
    'right',
    'top',
    'middle',
    'bottom',
  ]),
  typeM: PropTypes.oneOf([
    'left',
    'center',
    'right',
    'top',
    'middle',
    'bottom',
  ]),
  typeL: PropTypes.oneOf([
    'left',
    'center',
    'right',
    'top',
    'middle',
    'bottom',
  ]),
};

Align.defaultProps = {
  type: 'left',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-align/Align/index.js